<template>
  <div class="relative">
    <div v-if="is_loading" class="loading"></div>
    <div
      class="skill_box is-flex is-align-items-center is-justify-content-center"
      :class="{ 'is-loading': is_loading, 'is-revoked': is_revoked }"
    >
      <button class="button is-danger mx-1" @click="revoke">R</button>
      <button class="button is-danger mx-1" @click="deleteSkill">X</button>
      <div class="is-flex is-align-items-center" :class="{ 'has-background-info': classBlue }">
        <p class="m-0 mx-1">{{ applicant_skill.skill.name }}</p>
        <p class="m-0">({{ experience }})</p>
      </div>
      <div v-if="inputType">
        <input v-model.lazy="experience" v-bind="$attrs" class="input mx-1 width_60px" />
      </div>
      <div v-else class="is-flex">
        <button class="button is-info mx-1" @click="increase">+</button>
        <button class="button is-info mx-1" @click="decrease">-</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'applicant-skill',
  props: ['applicant_id', 'applicant_skill', 'classBlue', 'inputType'],
  data () {
    return {
      is_loading: false
    }
  },
  computed: {
    experience: {
      get: function () {
        return this.applicant_skill.experience || 0
      },
      set: function (newValue) {
        if (newValue && !isNaN(newValue) && newValue >= 0) {
          this.serverCall('updateApplicantSkill', 'change', {
            experience: newValue
          })
        }
      }
    },
    is_revoked () {
      return this.applicant_skill.details == undefined ? false : this.applicant_skill.details.revoked
    }
  },
  methods: {
    increase () {
      this.serverCall('updateApplicantSkill', 'inc_exp', {
        experience: this.experience + 1
      })
    },
    decrease () {
      this.serverCall('updateApplicantSkill', 'dec_exp', {
        experience: this.experience > 0 ? this.experience - 1 : this.experience
      })
    },
    deleteSkill () {
      this.serverCall('deleteApplicantSkill', 'delete')
    },
    revoke () {
      this.serverCall('updateApplicantSkill', 'revoke', {
        revoked: !this.is_revoked
      })
    },
    async serverCall (method, action, params) {
      this.is_loading = true
      await this.$network_utils[method]({
        id: this.applicant_skill.id,
        current_applicant_id: this.applicant_id,
        ...params
      })
      this.$emit('refresh', { action, skill: this.applicant_skill })
      this.is_loading = false
    }
  }
}
</script>
<style scoped>
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.is-loading {
  pointer-events: none;
  opacity: 0.5;
}
.has-background-info {
  background-color: hsl(217, 71%, 53%);
  color: white;
  padding: 0 5px;
}
</style>
